const Page = {
  handlePhone: function () {
    const input = document.querySelector('input[name="phone"]');
    if (input) input.addEventListener('input', function (e) {
      var x = e.target.value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,5})(\d{0,4})/);
      e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    });
  },
  handleTabs: function () {
    const anchors = document.querySelectorAll('.section-faq .faq .anchor');

    if (anchors.length > 0) 
      anchors.forEach(anchor => {
        anchor.addEventListener('click', () => {
          const dropdown = anchor.nextElementSibling;
    
          if(anchor.classList.contains('-active')){
            anchor.classList.remove('-active');
    
            dropdown.classList.remove('-active');
            dropdown.style.height = 0;

          } else {  
            anchor.classList.add('-active');
            
            dropdown.style.height = `${dropdown.scrollHeight}px`;
            setTimeout(() => { dropdown.classList.add('-active') }, 400);

          }
        });
      });
  },
  init: function () {
    let page = window.location.href;

    if (page.includes('atendimento')) 
      this.handlePhone();

    if (page.includes('duvidas-frequentes') || page.includes('pagamento') || page.includes('entregas') || page.includes('atendimento')) 
      this.handleTabs();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Page.init();
});
